import { render, staticRenderFns } from "./AddWarehouse.vue?vue&type=template&id=3cb9c249&"
import script from "./AddWarehouse.vue?vue&type=script&lang=ts&"
export * from "./AddWarehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports